// extracted by mini-css-extract-plugin
module.exports = {"BackupsModalSettings":"BackupsModalSettings_qqv6J","BackupsModalSwitchText":"BackupsModalSwitchText_zHD57","BackupsModalDatePicker":"BackupsModalDatePicker_qfdoe"};